export type TicketPreviewFetch = (
  input: RequestInfo | URL,
  init?: RequestInit,
) => Promise<Response>;

export async function loadTicketPdfPreview(
  url: string,
  signal?: AbortSignal,
  fetcher: TicketPreviewFetch = fetch,
): Promise<Blob> {
  const response = await fetcher(url, {
    credentials: 'omit',
    signal,
  });
  if (!response.ok) {
    throw new Error(`Unable to load attachment preview (${response.status})`);
  }

  const source = await response.blob();
  if (source.type === 'application/pdf') return source;
  return new Blob([source], { type: 'application/pdf' });
}
